define('models/merchants/giftcardconfig',['backbone'
], function (Backbone) {
    var GiftCardConfig = Backbone.Model.extend({
        url: function(){
            if(this.MGUID){
                return pf.consumerURL + '/eCards/Config?MerchantGUID=' + this.MGUID;
            } else {
                return pf.consumerURL + '/eCards/Config?MerchantGroupGUID=' + this.MGGUID;
            }
        },
        initialize: function (options) {
            options = options || {};
            this.MGUID = options.MGUID;
            this.MGGUID = options.MGGUID;
        },
        parse: function(data){
            var response = null;

            if(data){
                gAnalytics('giftCardConfig', this.MGUID + '-' + data.MNAME, '');
                
                response = {};
                
                response.MerchantID = data.MID;
                response.MerchantName = data.MNAME;
                response.DefaultMerchantGUID = data.DMG;
                response.MinAmount = data.MIN;
                response.MaxAmount = data.MAX;
                response.ConsumerRebatePercentage = data.CRP;
                response.ProductImagesLarge = data.PIL;
                response.ProductImagesXLarge = data.PIXL;
                response.ProductDescription = data.PD;
                response.ConfigufationId = data.ConfigufationId;
                response.TermsAndCondition = data.TC;
                response.HideRebate = data.HR;

            }
            
            return response;
        }
    });
    return GiftCardConfig;
});
